
export const openHouse = {
  title: "Open House Day",
  description: "Join us to discover our school!",
  subtitle: "We look forward to showing you why Gándara is the ideal choice for your child's academic future!",
  bookVisit: "Book your visit",
  lastSpots: "Last spots available for our next Open House! Book now!",
  discover: {
    title: "Discover Gándara International School",
    description: "with a personalised visit by appointment, from the first week of September."
  },
  methodology: {
    title: "At Gándara, we believe in personalized learning",
    description: "adapted to each student, and in developing skills for a global world."
  },
  flexibility: {
    title: "Our doors are open for you every day!",
    description: "We understand that family schedules can be complicated, that's why we offer maximum flexibility for you to visit us any day."
  }
};
